import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import ModelDataGrid from '../ModelDataGrid';
import ModelList from '../ModelList';

const Models: React.FC = () => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <ModelDataGrid />
      </If>
      <If condition={!isDesktop}>
        <ModelList />
      </If>
    </>
  );
};

export default React.memo(Models);